document.addEventListener('DOMContentLoaded', function() {
  const readMoreBtn = document.querySelector('.read_more');
  const productDescription = document.querySelector('.product__description');

  if (readMoreBtn && productDescription) {
    readMoreBtn.addEventListener('click', function() {
      // Toggle the class on product__description div when the button is clicked
      productDescription.classList.toggle('active');
    });
  }
});

/* =========================================================
   FREETIME — Miniatures produit verticales : 5 visibles + flèches
   (s'active seulement sur les fiches produit avec plus de 5 photos)
   ========================================================= */
(function () {
  if (!document.querySelector('media-gallery')) return; // pages produit uniquement
  var st = document.createElement('style');
  st.id = 'ft-thumbs-style';
  st.textContent = ".ft-thumbs--limited { display: flex !important; flex-direction: column !important; align-items: stretch; } .ft-thumbs--limited > .slider-button { display: none !important; } .ft-thumbs--limited ul.thumbnail-list { flex-wrap: nowrap !important; overflow-x: hidden !important; overflow-y: auto !important; scroll-snap-type: y mandatory; scroll-behavior: smooth; scrollbar-width: none; } .ft-thumbs--limited ul.thumbnail-list::-webkit-scrollbar { display: none; } .ft-thumbs--limited .thumbnail-list__item { flex-shrink: 0; scroll-snap-align: start; } .ft-thumbs-arrow { display: flex; align-items: center; justify-content: center; width: 100%; height: 32px; margin: 6px 0; padding: 0; border: 1px solid #e5e5e5; border-radius: 8px; background: #fff; color: #222; cursor: pointer; transition: background .2s ease, color .2s ease, border-color .2s ease, opacity .2s ease; } .ft-thumbs-arrow:hover:not([disabled]) { background: #F5853B; border-color: #F5853B; color: #fff; } .ft-thumbs-arrow[disabled] { opacity: .3; cursor: default; } .ft-thumbs-arrow svg { width: 16px; height: 16px; } .ft-thumbs-arrow[hidden] { display: none !important; }";
  document.head.appendChild(st);

  var VISIBLE = 5; // nombre de miniatures affichées
  var STEP = 1;    // nombre de miniatures qui défilent à chaque clic (mettre 5 pour défiler page par page)

  var CHEVRON_UP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"></polyline></svg>';
  var CHEVRON_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

  function visibleItems(list) {
    return Array.prototype.filter.call(
      list.querySelectorAll('.thumbnail-list__item'),
      function (li) { return li.offsetParent !== null; } // ignore les miniatures masquées
    );
  }

  function makeArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ft-thumbs-arrow ft-thumbs-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'up' ? 'Photos précédentes' : 'Photos suivantes');
    b.innerHTML = dir === 'up' ? CHEVRON_UP : CHEVRON_DOWN;
    b.hidden = true;
    return b;
  }

  function setup(slider) {
    if (slider.__ftThumbs) return slider.__ftThumbs;
    var list = slider.querySelector('ul.thumbnail-list');
    if (!list) return null;
    slider.classList.add('ft-thumbs-init'); // réaffiche toutes les miniatures (masquées au-delà de 5 par le CSS de theme.liquid)

    var up = makeArrow('up');
    var down = makeArrow('down');
    list.parentNode.insertBefore(up, list);
    list.parentNode.insertBefore(down, list.nextSibling);

    function stepSize() {
      var items = visibleItems(list);
      if (items.length < 2) return list.clientHeight;
      return items[1].offsetTop - items[0].offsetTop;
    }

    function refresh() {
      up.disabled = list.scrollTop <= 2;
      down.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
    }

    function deactivate() {
      slider.classList.remove('ft-thumbs--limited');
      list.style.maxHeight = '';
      up.hidden = down.hidden = true;
    }

    function layout() {
      // Uniquement quand les miniatures sont affichées en colonne (sur le côté) et visibles
      if (slider.offsetParent === null || getComputedStyle(list).flexDirection.indexOf('column') !== 0) {
        return deactivate();
      }
      var items = visibleItems(list);
      if (items.length <= VISIBLE) return deactivate();

      slider.classList.add('ft-thumbs--limited');
      up.hidden = down.hidden = false;
      list.style.maxHeight = 'none';
      var first = items[0];
      var last = items[VISIBLE - 1];
      var h = (last.offsetTop + last.offsetHeight) - first.offsetTop;
      if (h > 0) list.style.maxHeight = h + 'px';
      refresh();
    }

    function ensureVisible(li) {
      if (!slider.classList.contains('ft-thumbs--limited') || !li) return;
      var top = li.offsetTop;
      var bottom = top + li.offsetHeight;
      if (top < list.scrollTop) {
        list.scrollTo({ top: top, behavior: 'smooth' });
      } else if (bottom > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: bottom - list.clientHeight, behavior: 'smooth' });
      }
    }

    up.addEventListener('click', function () {
      list.scrollBy({ top: -stepSize() * STEP, behavior: 'smooth' });
    });
    down.addEventListener('click', function () {
      list.scrollBy({ top: stepSize() * STEP, behavior: 'smooth' });
    });
    list.addEventListener('scroll', refresh, { passive: true });

    // La miniature active reste visible quand la grande photo change
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'aria-current' && m.target.getAttribute('aria-current') === 'true') {
          ensureVisible(m.target.closest('.thumbnail-list__item'));
        }
      });
    }).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });

    slider.__ftThumbs = { layout: layout };
    return slider.__ftThumbs;
  }

  function scan() {
    document.querySelectorAll('media-gallery slider-component.thumbnail-slider').forEach(function (slider) {
      var api = setup(slider);
      if (api) api.layout();
    });
  }

  var t;
  function scheduleScan() { clearTimeout(t); t = setTimeout(scan, 120); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  window.addEventListener('resize', scheduleScan);

  // La galerie est re-dessinée quand on change de variante : on réapplique
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scheduleScan(); break; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* =========================================================
   FREETIME — Bulles de couleur sur les sacs à dos et les vêtements
   - Sacs City : bulle bicolore (gris du sac + couleur du logo)
   - Sacs avec pastilles Shopify (Paseo, Everest...) : agrandies au même format
   - Le Pack City n'est PAS concerné
   - Pour ajouter / corriger une couleur : modifier FT_COLORS ci-dessous
   ========================================================= */
(function () {
  var EXCLUDE = ['pack-city-1'];
  var BACKPACKS = [
    'sac-a-dos-city-g', 'sac-a-dos-city-m', 'sac-a-dos-city-k',
    'moby-30-l-le-sac-ultra-leger-610-g-et-ultra-pratiq',
    'nistos-35-sac-a-dos-filet-tendu-35-sport-intense',
    'nistos-28-sac-a-dos-filet-tendu-28l-porte-casque',
    'nistos-48-sac-a-dos-filet-tendu-48l-porte-casque',
    'paseo-25', 'peak15',
    'peak-25-sac-25l-ultra-leger-sport-intense-dos-aere',
    'peak-32-sac-32l-ultra-leger-sport-intense-dos-aere',
    'everest-sac-de-montagne-40l-ultra-complet',
    'everest-80l-sac-montagne-dos-reglable-ultra-complet',
    'everest-40-sac-a-dos-40l-trek-et-rando-en-montagne',
    'everest-40-1-5-sac-a-dos-de-trekking-et-randonnee-en-montagne-de-40-l',
    'taroko-45-sac-a-dos-45l-pour-randonnee-1-a-2-jours',
    'taroko-55-sac-de-randonnee-55l-dos-filet-tendu-ajustable',
    'taroko-65-sac-de-randonnee-65l-dos-trampoline-reglable',
    'active-12-sac-a-dos-12l-filet-tendu-porte-casque',
    'urban-cabin-bagage-cabine-35l-poche-pc-acces-rapide'
  ];
  var CLOTHING = [
    'cairn-jkt', 'womens-cairn-jacket', 'womens-talus-primaloft-jacket', 'mens-talus-jacket',
    'womens-machu-trousers', 'mens-machu-trousers', 'mens-nevis-trousers', 'paklite-jacket',
    'womens-voyage-shirt', 'mens-voyage-shirt', 'womens-trail-pro-short-sleeve-top-with-stayfresh',
    'mens-ads-100-t-shirt', 'womens-bidean-short', 'mens-bidean-shorts',
    'womens-peru-combat-shorts', 'mens-peru-combat-shorts', 'insect-shield-hiker-socks'
  ];

  // Couleurs (sans accents, en minuscules). Les noms les plus longs sont testés en premier.
  var FT_COLORS = {
    'gris fonce': '#4B4E52', 'gris clair': '#C4C6C9', 'gris': '#8A8D91',
    'noir': '#1E1E1E', 'graphite': '#3E4247', 'marine': '#1F2A44',
    'bleu ciel': '#8EC5E8', 'bleu ocean': '#1F5F8B', 'bleu': '#2F6FD6',
    'rouge': '#D93A2B', 'lie-de-vin': '#6E1F2E', 'lie de vin': '#6E1F2E',
    'vert olive': '#6B7A3A', 'vert': '#4E8A3E', 'jaune': '#F2C230', 'orange': '#F07D1A'
  };
  // Couleurs du logo des sacs City
  var FT_LOGO = { 'rouge': '#D93A2B', 'bleu': '#2F6FD6', 'vert': '#7DBB3C' };
  var SILVER = 'linear-gradient(135deg,#f4f5f7 0%,#9aa1a8 40%,#ffffff 60%,#b3b9bf 100%)';

  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]);
  if (EXCLUDE.indexOf(handle) !== -1) return;
  var type = '';
  try { type = (window.ShopifyAnalytics && ShopifyAnalytics.meta.product.type) || ''; } catch (e) {}
  var enabled = BACKPACKS.indexOf(handle) !== -1 || CLOTHING.indexOf(handle) !== -1 ||
    /backpack|sac (a|à) dos|clothing|v(e|ê)tement/i.test(type);
  if (!enabled) return;
  document.documentElement.classList.add('ft-sw-page');

  var css = [
    '.ft-swatches{display:flex!important;flex-wrap:wrap;align-items:center;gap:12px;}',
    '.ft-swatches legend{width:100%;margin-bottom:6px;}',
    '.ft-swatches .ft-swatch-name{font-weight:400;font-size:.85em;color:#555;margin-left:4px;}',
    '.ft-swatches input[type=radio]+label{',
      'position:relative;width:40px;height:40px;min-width:40px;padding:0!important;margin:0!important;',
      'border-radius:50%!important;border:1px solid rgba(0,0,0,.18)!important;',
      'font-size:0!important;line-height:0!important;color:transparent!important;text-decoration:none!important;',
      'background:var(--ft-bg,#ccc)!important;box-shadow:none!important;cursor:pointer;',
      'transition:transform .15s ease,box-shadow .15s ease;}',
    '.ft-swatches input[type=radio]+label:hover{transform:scale(1.08);}',
    '.ft-swatches input[type=radio]:checked+label{box-shadow:0 0 0 2px #fff,0 0 0 4px #222!important;}',
    '.ft-swatches input[type=radio]:focus-visible+label{outline:2px solid #F5853B;outline-offset:4px;}',
    '.ft-swatches input[type=radio].disabled+label{opacity:.35;}',
    '.ft-swatches input[type=radio].disabled+label::after{content:"";position:absolute;left:50%;top:-2px;width:1.5px;height:44px;background:#222;transform:rotate(45deg);}',
    /* pastilles de couleur Shopify déjà existantes : même format que les bulles */
    '.ft-sw-page variant-selects .product-form__input--swatch{display:flex!important;flex-wrap:wrap;align-items:center;gap:12px;}',
    '.ft-sw-page variant-selects .product-form__input--swatch legend{width:100%;margin-bottom:6px;}',
    '.ft-sw-page variant-selects .product-form__input--swatch legend [data-selected-value]{font-weight:400;font-size:.85em;color:#555;margin-left:4px;}',
    '.ft-sw-page variant-selects .swatch-input__label{margin:0!important;padding:0!important;border-radius:50%!important;outline:none!important;line-height:0;cursor:pointer;transition:transform .15s ease;}',
    '.ft-sw-page variant-selects .swatch-input__label:hover{transform:scale(1.08);}',
    '.ft-sw-page variant-selects .swatch-input__label .swatch{width:40px!important;height:40px!important;min-width:40px;outline:none!important;border:1px solid rgba(0,0,0,.18)!important;border-radius:50%!important;box-shadow:none!important;transition:box-shadow .15s ease;}',
    '.ft-sw-page variant-selects .swatch-input__input:checked+.swatch-input__label{outline:none!important;}',
    '.ft-sw-page variant-selects .swatch-input__input:checked+.swatch-input__label .swatch{box-shadow:0 0 0 2px #fff,0 0 0 4px #222!important;}'
  ].join('');
  var st = document.createElement('style');
  st.id = 'ft-swatches-style';
  st.textContent = css;
  document.head.appendChild(st);

  var KEYS = Object.keys(FT_COLORS).sort(function (a, b) { return b.length - a.length; });
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); }
  function findColor(s) {
    s = norm(s);
    for (var i = 0; i < KEYS.length; i++) if (s.indexOf(KEYS[i]) !== -1) return FT_COLORS[KEYS[i]];
    return null;
  }
  // Renvoie le fond CSS de la bulle, ou null si la couleur est inconnue
  function background(value) {
    var parts = value.split(/\s+[–—-]\s+/);
    if (parts.length === 2 && /^logo\b/i.test(norm(parts[1]))) {
      var base = findColor(parts[0]);
      var logoTxt = norm(parts[1]).replace(/^logo\s+/, '');
      if (!base) return null;
      if (/reflechissant/.test(logoTxt)) {
        return 'linear-gradient(135deg,' + base + ' 0 50%,transparent 50% 100%),' + SILVER;
      }
      var logo = FT_LOGO[logoTxt] || findColor(logoTxt);
      if (!logo) return null;
      return 'linear-gradient(135deg,' + base + ' 0 50%,' + logo + ' 50% 100%)';
    }
    var c = findColor(value);
    return c ? c : null;
  }

  var COLOR_OPTION = /couleur|coloris|colou?rs?/i;

  function update() {
    document.querySelectorAll('variant-selects fieldset.product-form__input--pill').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !COLOR_OPTION.test(legend.textContent)) return;
      var inputs = fs.querySelectorAll('input[type=radio]');
      var bgs = [];
      for (var i = 0; i < inputs.length; i++) {
        var bg = background(inputs[i].value);
        if (!bg) return; // une couleur inconnue : on laisse ce choix tel quel
        bgs.push(bg);
      }
      inputs.forEach(function (inp, i) {
        var lab = fs.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        if (lab.style.getPropertyValue('--ft-bg') !== bgs[i]) lab.style.setProperty('--ft-bg', bgs[i]);
        if (lab.title !== inp.value) lab.title = inp.value;
      });
      if (!fs.classList.contains('ft-swatches')) fs.classList.add('ft-swatches');
      var checked = fs.querySelector('input[type=radio]:checked');
      if (!checked) return;
      var name = legend.querySelector('.ft-swatch-name');
      if (!name) {
        legend.textContent = legend.textContent.trim().replace(/\s*:.*$/, '') + ':';
        name = document.createElement('span');
        name.className = 'ft-swatch-name';
        legend.appendChild(name);
      }
      if (name.textContent !== checked.value) name.textContent = checked.value;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  document.addEventListener('change', function () { setTimeout(update, 0); });
  // Réappliqué immédiatement quand le thème redessine le sélecteur (changement de variante)
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { update(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* =========================================================
   FREETIME — Popup « La gamme CITY vient d'arriver » (page d'accueil)
   ⚡ PERF : le script de la page d'accueil ouvrait ce popup 3,5 s après le
   chargement, ce qui faisait chuter le score Google (LCP) sur mobile.
   Ici on bloque cette ouverture automatique et on ouvre le popup 3,5 s après
   la PREMIÈRE INTERACTION du visiteur (défilement, toucher, clic, souris, clavier).
   Toujours une seule fois par visite.
   ========================================================= */
(function () {
  var modal = document.getElementById('ft-promo-modal');
  if (!modal) return;
  var KEY = 'ft-promo-city-shown'; // clé lue par le script de la page d'accueil
  var DONE = 'ft-promo-city-done'; // popup réellement affiché pendant cette visite
  try {
    if (sessionStorage.getItem(DONE)) return;
    sessionStorage.setItem(KEY, '1'); // empêche l'ouverture au chargement
  } catch (e) { return; }
  var events = ['scroll', 'pointerdown', 'touchstart', 'mousemove', 'keydown'];
  var timer = null;
  function start() {
    if (timer) return;
    events.forEach(function (ev) { window.removeEventListener(ev, start); });
    timer = setTimeout(function () {
      modal.classList.add('ft-promo-visible');
      try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
    }, 3500);
  }
  events.forEach(function (ev) { window.addEventListener(ev, start, { passive: true }); });
})();

/* =========================================================
   FREETIME — Vidéo d'accueil
   ⚡ PERF : la vidéo démarre après le chargement de la page ET la première
   interaction du visiteur (défilement, toucher, souris, clavier).
   Avant, Google comptait l'image de la vidéo qui démarre comme « plus grand
   élément » (LCP) => score mobile très bas. En attendant, la photo d'accueil
   est affichée (même image que la vidéo).
   ========================================================= */
(function () {
  var v = document.getElementById('ft-hero-video');
  if (!v) return;
  var s = v.querySelector('source[data-src]');
  if (!s) return;
  // on retire data-src pour que le script de la page d'accueil ne lance pas la vidéo au chargement
  s.setAttribute('data-ft-src', s.getAttribute('data-src'));
  s.removeAttribute('data-src');
  var events = ['scroll', 'pointerdown', 'touchstart', 'mousemove', 'keydown'];
  var interacted = false, started = false, loaded = document.readyState === 'complete';
  function tryStart() {
    if (started || !interacted || !loaded) return;
    started = true;
    s.src = s.getAttribute('data-ft-src');
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {}); // lecture bloquée : la photo reste affichée
  }
  function onInteract() {
    interacted = true;
    events.forEach(function (ev) { window.removeEventListener(ev, onInteract); });
    tryStart();
  }
  events.forEach(function (ev) { window.addEventListener(ev, onInteract, { passive: true }); });
  if (!loaded) window.addEventListener('load', function () { loaded = true; tryStart(); });
})();
